// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Calendar from '../_raw/ui/icon_calendar.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Calendar);
